import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { CurrencyFormat } from "../../../Helpers/Formatters";
import { CurrencyFormatFunc } from "../../../Helpers/Formatters/CurrencyFormat";
import IconHolder from "../../../Helpers/IconHolder";
import ScheduleCalender from '../../../../icons/schedulecalender.svg?react';
import { ProductDetailsDialog } from "./ProductDetailModel";
import ProductDetails from "../../FullUW/Helpers/ProductDetails";
import './AppointmentProductDetail.scss';

export default function AppointmentProductDetail(props) {
  const { quote } = props;
  const [isProductDetailsDialogOpen, setIsProductDetailsDialogOpen] = useState(false);

  return (
    <div>
      <Row className="coverage-detail">
        {!quote || quote.isSelectOrTalk === "contactSpecialist" ?
          <Col className="carrier-container text-center d-flex justify-content-center align-items-center pe-0 pt-2">
            <div className="mt-1">
              <IconHolder icon={ScheduleCalender} viewBox="0 0 25 25"/>
            </div>
            <Typography variant="body1" component="div">
              <h6 className='mt-2'><b>TERM LIFE INSURANCE</b></h6>
            </Typography>
          </Col>
          :
          <Col className="carrier-container carrier-logo-container text-center pe-0 pt-3">
            <img src={quote.carrierLogoUrl} alt="Carrier Logo"
                 className={(quote.carrierName && quote.carrierName.toLowerCase() === "lga") ? "lg" : ""}/>
            <p className="ratingText">{quote.selectedQuote && quote.selectedQuote.rating} Rating</p>
          </Col>
        }
        <Col className="carrier-container d-flex justify-content-center align-items-start ps-0">
          <div className="coverage mt-3">
            <h6><b>Coverage Amount</b></h6>
            <p className="coverage-amount"><CurrencyFormat number={quote.coverageAmount} whole /></p>
            <p className="quote-amount">{quote.premium ? `${CurrencyFormatFunc(quote.premium)}/mo` : ''}
              <span>{quote.termLength} Year Term</span></p>
            {quote.isSelectOrTalk === "quoteSelect" &&
              <button type="button" className="ratingText product-detail-btn"
                      onClick={() => setIsProductDetailsDialogOpen(true)}>Approval Process</button>}
          </div>
        </Col>
      </Row>
      {quote.isSelectOrTalk === "quoteSelect" && props.quote.selectedQuote &&
        <ProductDetailsDialog
          isOpen={isProductDetailsDialogOpen}
          productDetails={
            <ProductDetails
              carrierName={props.quote.selectedQuote.carrierName}
              productDescription={props.quote.selectedQuote.productDescription}
              hasPermConversion={props.quote.selectedQuote.hasConvertibility}
              productInformation={props.quote.selectedQuote.productInformation}
            />
          }
          quoteCardProps={props.quote.selectedQuote}
          hideSelect
          onClose={() => setIsProductDetailsDialogOpen(false)}
        />
      }
    </div>
  );
}

AppointmentProductDetail.propTypes = {
  quote:PropTypes.object
};
